export enum StoragePlusAction {
	SCHEDULE = "schedule",
	UNSCHEDULE = "unschedule",
	TRASH = "trash",
	UNTRASH = "untrash",
	DELETE = "delete",
}
